import Model from 'flarum/common/Model';
export default class AuditLog extends Model {
  actorId() {
    return Model.attribute('actorId').call(this);
  }
  client() {
    return Model.attribute('client').call(this);
  }
  ipAddress() {
    return Model.attribute('ipAddress').call(this);
  }
  action() {
    return Model.attribute('action').call(this);
  }
  payload() {
    return Model.attribute('payload').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  actor() {
    return Model.hasOne('actor').call(this);
  }
  discussion() {
    return Model.hasOne('discussion').call(this);
  }
  newDiscussion() {
    return Model.hasOne('newDiscussion').call(this);
  }
  post() {
    return Model.hasOne('post').call(this);
  }
  tag() {
    return Model.hasOne('tag').call(this);
  }
  user() {
    return Model.hasOne('user').call(this);
  }
}
flarum.reg.add('flarum-audit', 'common/models/AuditLog', AuditLog);